import { render, staticRenderFns } from "./cardVirtualConversation.vue?vue&type=template&id=75572f54"
import script from "./cardVirtualConversation.vue?vue&type=script&lang=js"
export * from "./cardVirtualConversation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports